import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import type { ApiServerEntityIDType } from '../../../types';
import { ClientInterviewStatus } from './status';

export class ClientInterviewViewModel {
  @Expose()
  @ApiProperty()
  id: ApiServerEntityIDType;

  @Expose()
  @ApiProperty()
  clientId: ApiServerEntityIDType;

  @Expose()
  @ApiProperty()
  adminId?: ApiServerEntityIDType;

  @Expose()
  @ApiProperty({ enum: ClientInterviewStatus, enumName: 'ClientInterviewStatus' })
  status: ClientInterviewStatus;

  @Expose()
  @ApiProperty()
  startedAt: string; // Date ISO string

  @Expose()
  @ApiProperty()
  endedAt: string; // Date ISO string

  @Expose()
  @ApiProperty()
  createdAt: string; // Date ISO string

  @Expose()
  @ApiProperty()
  updatedAt: string; // Date ISO string
}
